import "core-js/modules/es.object.to-string.js";
import { getToken as _getToken } from '@/api/qiniu';
var state = {
  Token: null,
  Expire_time: 0,
  loading: false
};
var mutations = {
  SET_Token: function SET_Token(state, data) {
    state.Token = data;
  },
  SET_Expire_time: function SET_Expire_time(state, data) {
    state.Expire_time = data;
  },
  SET_LOADING: function SET_LOADING(state, loading) {
    state.loading = loading;
  }
};
var actions = {
  getToken: function getToken(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      var timestamp = new Date().getTime();

      if (state.loading) {
        resolve(state.Token);
      } else if (state.Token == null || state.Expire_time < timestamp) {
        commit('SET_LOADING', true);

        _getToken().then(function (response) {
          commit('SET_Token', response.data);
          commit('SET_Expire_time', timestamp + 100 * 1000); // 100 秒刷新

          commit('SET_LOADING', false);
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
          commit('SET_LOADING', false);
        });
      } else {
        resolve(state.Token);
      }
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};